import { StyleSheet } from "react-native"
import { baseColors, basePadding } from "@Constants/baseStyles"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: baseColors.white
    },
    content: {
        paddingHorizontal: basePadding.paddingHorizontal,
        paddingVertical: basePadding.paddingVertical
    }
})

export default styles
